import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import React from 'react';
import { View } from '../View';
import * as styles from './Card.styles';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<{}, 'div'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function CardInnerBody(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'CardInnerBody'),
      className = _useContextSystem.className,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className"]);

  var classes = cx(styles.InnerBody, className);
  return /*#__PURE__*/React.createElement(View, Object.assign({}, otherProps, {
    className: classes,
    ref: forwardedRef
  }));
}

export default contextConnect(CardInnerBody, 'CardInnerBody');